module.exports = __webpack_public_path__ + "assets/img/mace.74712d8d.png";